import _ from "lodash";
import moment from 'moment';
const config = (context) => {
    return {
        hideListHeader: true,
        editPath: "cases",
        pageTitle: "Cases",
        pageIcon: "work",
        listQueryId: "searchCaseServicesDetails",
        responseFieldName: "searchCaseServices",
        linkRows: false,
        searchRecordsInput: false,
        hideActionColumn: true,
        columns: {
            case: { label: "Case", sortable: true },
            portfolio: { label: "Portfolio", sortable: true },
            isRestructured: { label: "Restructured", sortable: true },
            account: { label: "Account", sortable: true },
            merchantNumber: { label: "Merchant Number", sortable: true },
            subject: { label: "Subject", sortable: true },
            type: { label: "Case Type", sortable: true },            
            status: { label: "Status", sortable: true },            
            approvalDate: { label: "Approval Date", sortable: true, dateFilter: true },            
            createdAt: { label: "Date/Time Opened", sortable: true, dateFilter: true },
        },
        ignoreSortColumns: [
            "case",
            "portfolio",
            "isRestructured",
            "account",
            "merchantNumber",
            "subject",
            "type",            
            "status",            
            "approvalDate",            
            "createdAt",
        ],
        perPageOptions: [10, 20, 25, 50],
        defaults: {
            sort: "createdAt",
            sortDir: "desc",
            perPage: 10,
        },
        fuseSearch: null,
        formatResponse: (data) => {
            return context.formatResponse(data);
        },
    };
};

export default config;
